var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellnessVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Health and Beauty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Health and Beauty Icon")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4119,33.243 C43.4119,38.86 38.8589,43.414 33.2419,43.414 C27.6239,43.414 23.0709,38.86 23.0709,33.243 C23.0709,27.626 27.6239,23.073 33.2419,23.073 C38.8589,23.073 43.4119,27.626 43.4119,33.243 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.971,8.8378 C36.971,12.1058 35.527,15.0418 33.242,17.0218 C30.957,15.0418 29.513,12.1058 29.513,8.8378 C29.513,5.5698 30.957,2.6338 33.242,0.6538 C35.527,2.6338 36.971,5.5698 36.971,8.8378 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9671,57.492 C37.1111,60.757 35.7981,63.754 33.6021,65.832 C31.2321,63.955 29.6601,61.086 29.5161,57.821 C29.3721,54.556 30.6851,51.559 32.8811,49.48 C35.2511,51.358 36.8231,54.227 36.9671,57.492 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0306,18.5072 C50.7196,20.8182 47.6226,21.8732 44.6066,21.6572 C44.3906,18.6412 45.4456,15.5442 47.7566,13.2332 C50.0676,10.9222 53.1646,9.8672 56.1806,10.0832 C56.3956,13.0992 55.3416,16.1962 53.0306,18.5072 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6239,52.9081 C16.4169,55.3191 13.3699,56.5091 10.3479,56.4271 C9.9989,53.4231 10.9159,50.2831 13.1229,47.8721 C15.3299,45.4611 18.3769,44.2711 21.3989,44.3541 C21.7479,47.3571 20.8309,50.4971 18.6239,52.9081 Z",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6468,36.9725 C54.3788,36.9725 51.4428,35.5285 49.4628,33.2435 C51.4428,30.9585 54.3788,29.5145 57.6468,29.5145 C60.9158,29.5145 63.8508,30.9585 65.8308,33.2435 C63.8508,35.5285 60.9158,36.9725 57.6468,36.9725 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.993,36.9686 C5.728,37.1126 2.731,35.7996 0.652,33.6046 C2.53,31.2346 5.399,29.6616 8.664,29.5176 C11.929,29.3736 14.926,30.6866 17.004,32.8826 C15.127,35.2526 12.258,36.8246 8.993,36.9686 Z",
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9779,53.0321 C45.6669,50.7211 44.6119,47.6241 44.8279,44.6081 C47.8439,44.3921 50.9409,45.4471 53.2519,47.7581 C55.5619,50.0691 56.6179,53.1661 56.4019,56.1821 C53.3859,56.3981 50.2889,55.3431 47.9779,53.0321 Z",
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5765,18.6258 C11.1655,16.4188 9.9755,13.3708 10.0575,10.3488 C13.0615,10.0008 16.2015,10.9178 18.6125,13.1248 C21.0235,15.3308 22.2135,18.3788 22.1315,21.4008 C19.1275,21.7498 15.9875,20.8328 13.5765,18.6258 Z",
    id: "Stroke-17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessVertical);
export default __webpack_public_path__ + "static/media/wellness-vertical.8a638b55fdb66f6b727217130eb8a424.svg";
export { ForwardRef as ReactComponent };